import { postData } from './utils';
import { CAMPAIGN } from './mediaPlanning';

export const getXls = async ({ planId }: { planId: string }) => {
  return postData<string>(
    `/${CAMPAIGN}/generate-xls`,
    {},
    {
      params: { planId },
      responseType: 'text',
    }
  );
};
